module.exports = __webpack_public_path__ + "static/media/color-scheme.4841a18d.svg";